import {GetStaticProps} from "next";
import {config} from "../../config-merchant";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import HeaderAppyShop, {getComponentStaticProps, HeaderProps} from "../../components/header/headerAppyShop";
import {appyShopConfig} from "../../config";
import Meta from "../../components/meta/meta";
import FooterAppyShop from "../../components/footer/footerAppyShop";
import React, {useEffect, useState} from "react";
import {useTranslation} from "next-i18next";
import {Customer, ShopState} from "../../interfaces/store-interfaces";
import {useDispatch, useSelector} from "react-redux";
import {logout} from "../../store/action";
import {useRouter} from "next/router";
import {getOrderList, isJwtValid} from "../../services/customer-services";
import styles from "./my-account.module.scss";
import {OrderDTO} from "../../interfaces/customer-interface";
import Address from "../../components/customer/address";
import {MyAccountOrder} from "../../components/customer/account-order";
import Loader from "../../components/loader/loader";
import Link from 'next/link';

function MyAccount(props: {
    headerProps: HeaderProps,
}) {

    const {t} = useTranslation('common');
    const {i18n} = useTranslation('common')
    const router = useRouter();
    const [orderList, setOrderList] = useState<OrderDTO[]>();

    const dispatch = useDispatch();
    const customer: Customer = useSelector((state: ShopState) => state.customer);

    const getOrders = () => {
        getOrderList(customer.jwt)
            .then(resp => {
                setOrderList(resp.data);
            })
            .catch(err => {
                console.log(err);
                setOrderList([]);
            })
    }

    useEffect(() => {
        if (customer === undefined || customer === null) {
            router.push("login");
        } else {
            if (!isJwtValid(customer.jwt)) {
                dispatch(logout());
            } else {
                getOrders();
            }
        }
    }, [customer]);

    return (
        <>
            <Meta
                title={t('MY_ACCOUNT_TITLE')}
                description={config.shopSlogan[i18n.language]}
                image={config.merchantDomain + config.defaultMetaImage}
                metaRobots={false}
            />
            <HeaderAppyShop headerProps={props.headerProps} activepage={'my-account'}/>
            <main>
                {
                    customer !== undefined && customer !== null &&
                    <div className={styles["customer-infos"]}>

                        <div className={styles["title"]}>
                            <p>{t("MY_ACCOUNT_TITLE")}</p>
                            <p>{t("MY_ACCOUNT_SUBTITLE")}</p>
                            <div className={styles["disconnect"]} onClick={() => dispatch(logout())}>
                                <span>{t('MY_ACCOUNT_LOGOUT')}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g transform="translate(-2 -2)">
                                        <path className={styles["ic-logout-a"]}
                                              d="M9,22H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2H9A1,1,0,0,1,9,4H5A1,1,0,0,0,4,5V19a1,1,0,0,0,1,1H9a1,1,0,0,1,0,2Z"/>
                                        <path className={styles["ic-logout-a"]}
                                              d="M16,18a1,1,0,0,1-.707-1.707L19.586,12,15.293,7.707a1,1,0,0,1,1.414-1.414l5,5a1,1,0,0,1,0,1.414l-5,5A1,1,0,0,1,16,18Z"/>
                                        <path className={styles["ic-logout-a"]}
                                              d="M12,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H12a1,1,0,0,1,1,1A1,1,0,0,1,12,1Z"
                                              transform="translate(9 12)"/>
                                    </g>
                                </svg>
                            </div>
                        </div>

                        <div className={styles["personal-row"]}>

                            <div className={styles["row-title"]}>
                                <div className={styles["row-icon"]}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12.667" height="19"
                                         viewBox="0 0 12.667 19">
                                        <g transform="translate(-727.195 -400.236)">
                                            <path className={styles["ic-personal-a"]}
                                                  d="M8.222,11.444A4.222,4.222,0,1,0,4,7.222,4.222,4.222,0,0,0,8.222,11.444Zm0-2.111A2.111,2.111,0,1,0,6.111,7.222,2.111,2.111,0,0,0,8.222,9.333Z"
                                                  transform="translate(725.306 397.236)"/>
                                            <path className={styles["ic-personal-b"]}
                                                  d="M11.5,14.111a1.056,1.056,0,0,1,1.056,1.056V21.5h2.111V15.167A3.167,3.167,0,0,0,11.5,12H5.167A3.167,3.167,0,0,0,2,15.167V21.5H4.111V15.167a1.056,1.056,0,0,1,1.056-1.056Z"
                                                  transform="translate(725.195 397.736)"/>
                                        </g>
                                    </svg>
                                </div>
                                <div className={styles["row-text"]}>
                                    <p>{t("MY_ACCOUNT_PERSONAL_INFO")}</p>
                                </div>
                            </div>

                            <div className={styles["row-contents"]}>

                                <p className={styles["customer-id"]}>{customer.email}</p>
                                <p>{customer.phone}</p>

                                <div className={styles["row-columns"]}>
                                    <div>
                                        <p className={styles["subtitle"]}>{t("MY_ACCOUNT_DELIVERY_ADDRESS")}</p>
                                        <Address address={customer.defaultDeliveryAddress}/>
                                    </div>
                                    <div>
                                        <p className={styles["subtitle"]}>{t("MY_ACCOUNT_BILLING_ADDRESS")}</p>
                                        <Address address={customer.defaultBillingAddress}/>
                                    </div>
                                </div>

                                <Link href={`/my-account/update`}>
                                    <div className={styles["button-update-profile"]}>
                                        {t("MY_ACCOUNT_UPDATE_BUTTON")}
                                    </div>
                                </Link>

                            </div>

                        </div>

                        {/* TODO custom field */}

                        <div className={styles["orders-row"]}>

                            <div className={styles["row-title"]}>
                                <div className={styles["row-icon"]}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19.649" height="19.649"
                                         viewBox="0 0 19.649 19.649">
                                        <path className={styles["ic-orders-a"]}
                                              d="M4.947,3.965H18.7a.982.982,0,0,1,.982.982V18.7a.982.982,0,0,1-.982.982H4.947a.982.982,0,0,1-.982-.982V4.947A.982.982,0,0,1,4.947,3.965ZM2,4.947A2.947,2.947,0,0,1,4.947,2H18.7a2.947,2.947,0,0,1,2.947,2.947V18.7A2.947,2.947,0,0,1,18.7,21.649H4.947A2.947,2.947,0,0,1,2,18.7Zm9.824,6.877c-2.713,0-4.912-2.639-4.912-5.895H8.877c0,2.521,1.64,3.93,2.947,3.93s2.947-1.409,2.947-3.93h1.965C16.737,9.185,14.537,11.824,11.824,11.824Z"
                                              transform="translate(-2 -2)"/>
                                    </svg>
                                </div>
                                <div className={styles["row-text"]}>
                                    <p>{t("MY_ACCOUNT_ORDERS")}</p>
                                </div>
                            </div>

                            {orderList === undefined && <Loader/>}
                            {
                                orderList !== undefined && orderList.length === 0 &&
                                <div className={styles["no-order-text"]}>
                                    <p>{t("MY_ACCOUNT_NO_ORDER")}</p>
                                </div>
                            }
                            <div className={styles["row-contents"]}>
                                {
                                    orderList !== undefined && orderList.map(order => (
                                        <MyAccountOrder
                                            key={order.id}
                                            order={order}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                }
            </main>
            <FooterAppyShop/>
        </>
    );
}

export const getStaticProps: GetStaticProps = async ({locale}) => {
    if (config.menu.some(item => item.path === 'catalog') || config.footerLink.some(item => item.url === '/catalog')) {
        return {
            props: {
                ...await serverSideTranslations(locale, ['common']),
                headerProps: await getComponentStaticProps(locale)
            },
            revalidate: appyShopConfig.revalidateData
        }
    } else {
        return {
            notFound: true
        }
    }
}

export default MyAccount;
